import {isValidEmail} from "@/libs/Helpers";
import cookieSetterGetter from "@/libs/Cookie";
import LocalEncryption from "@/libs/Encryption";

class LoginStorage {
    constructor() {
        this.storageKey = 'user_ref';
    }

    registerEmail(email) {
        let emailEncrypt = null;
        if (isValidEmail(email)) {
            emailEncrypt = LocalEncryption.encrypt(email);
            cookieSetterGetter.setCookie(this.storageKey, emailEncrypt);
        }
        return emailEncrypt;
    }

    get emailAlreadyRegistered() {
        return this.emailRegistered !== null;
    }

    get emailRegistered() {
        let emailCookie = cookieSetterGetter.getCookie(this.storageKey);
        let email = LocalEncryption.decrypt(emailCookie);
        return isValidEmail(email) === true ? email : null;
    }

    get emailRegisteredRef() {
        return cookieSetterGetter.getCookie(this.storageKey);
    }

}

export default new LoginStorage();